import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ResourcesComponent } from './resources/resources.component';
import { ContactComponent } from './contact/contact.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { InspectionComponent } from './inspection/inspection.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { DateTableComponent } from './contact/date-table/date-table.component';
import { ContactFormComponent } from './contact/contact-form/contact-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { InspectionProcessTimelineComponent } from './inspection-process-timeline/inspection-process-timeline.component';
import { HeroScrollCueDirective } from './hero-scroll-cue.directive';

@NgModule({
  declarations: [
    AppComponent,
    ResourcesComponent,
    ContactComponent,
    HomeComponent,
    AboutComponent,
    InspectionComponent,
    NavbarComponent,
    FooterComponent,
    InspectionProcessTimelineComponent,
    DateTableComponent,
    ContactFormComponent,
    PrivacyPolicyComponent,
    HeroScrollCueDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
